// extracted by mini-css-extract-plugin
module.exports = {"productDiv":"ProductDetail_productDiv__3eCir","productTitleFont":"ProductDetail_productTitleFont__3H-13","productFont":"ProductDetail_productFont__1sU-d"};